import React, { Component } from 'react';
import { Row, Col, Table } from 'reactstrap';
import DemographicsGraph from '../../components/GraphResults/DemographicsGraph.js';
import CollapseCard from '../../components/CollapseCard/CollapseCard.js'
import { Link } from 'react-router-dom';

class AdvisorView extends Component {

    render() {
        const clientList = [
            { type: '(a) Individuals', account: 'Individual Accounts', aum: 'Individual AUM' },
            { type: '(b) High Net Worth Individuals', account: 'HNW Accounts', aum: 'HNW AUM' },
            { type: '(c) Banking or Thrift Institutions', account: 'Banking or Thrift Institutions Accounts', aum: 'Banking or Thrift Institutions AUM' },
            { type: '(d) Investment Companies', account: 'Investment Companies Accounts', aum: 'Investment Companies AUM' },
            { type: '(e) Business Development Companies', account: 'Business Development Companies Accounts', aum: 'Business Development Companies AUM' },
            { type: '(f) Pooled Investment Vehicles', account: 'Pooled Investment Vehicles Accounts', aum: 'Pooled Investment Vehicles AUM' },
            { type: '(g) Pension and Profit Sharing Plans', account: 'Pension Accounts', aum: 'Pension AUM' },
            { type: '(h) Charitable Organizations', account: 'Charitable Organizations Accounts', aum: 'Charitable Organizations AUM' },
            { type: '(i) State/Municipal Government Entities', account: 'Government Entities Accounts', aum: 'Government Entities AUM' },
            { type: '(j) Other Investment Advisers', account: 'Other Investment Advisors Accounts', aum: 'Other Investment Advisors AUM' },
            { type: '(k) Insurance Companies', account: 'Insurance Companies Accounts', aum: 'Insurance Companies AUM' },
            { type: '(l) Sovereign Wealth Funds / Foreign Insitutions', account: 'Sovereign Wealth Funds and Foreign Official Institutions Accounts', aum: 'Sovereign Wealth Funds and Foreign Official Institutions AUM' },
            { type: '(m) Other Businesses Not Listed Above', account: 'Corporations Not Listed Accounts', aum: 'Corporations Not Listed AUM' },
            { type: '(n) Family Foundations', account: 'Family Foundations Accounts', aum: 'Family Foundations AUM' }
        ];
        const clientListFiltered = clientList.filter(c => this.props.data[c.aum] > 0);

        const totalList = [
            { type: 'Discretionary', account: 'Discretionary Accounts', aum: 'Discretionary AUM' },
            { type: 'Non-Discretionary', account: 'Non-Discretionary Accounts', aum: 'Non-Discretionary AUM' },
            { type: 'Total', account: 'Total Accounts', aum: 'Total AUM' }
        ];
        const totalListFiltered = totalList.filter(c => this.props.data[c.aum] > 0);

        var clientAUMTotal = 0;
        var clientAccountTotal = 0;
        clientListFiltered.forEach(i => {
            clientAUMTotal += parseFloat(this.props.data[i.aum]);
            clientAccountTotal += parseFloat(this.props.data[i.account]);
        });
        return (
            <CollapseCard title={<>{(this.props.id > 0) ? <><Link to={{ pathname: '/demographics/' + this.props.data['SEC#'], state: { currentDate: this.props.currentDate } }}>{this.props.data['SEC#']}</Link> - </> : <></>} {' ' + (this.props.data.Name) + ((this.props.master) ? ' (Master)' : '')}</>} open={true}>
                <Row>
                    <Col md={12} className="text-left">
                        <Row>
                            <Col md={12} xl={5}>
                                {(clientAUMTotal > 0 || clientAccountTotal > 0) ?
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="text-left">AUM</th>
                                                <th className="text-right">Value</th>
                                                <th className="text-right">Accounts</th>
                                                <th className="text-right">Avg. Size/Acct.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clientListFiltered.map(c => (
                                                <tr key={c.type}>
                                                    <td className="text-left">{c.type}</td>
                                                    <td className="text-right">${new Intl.NumberFormat().format(this.props.data[c.aum])}</td>
                                                    <td className="text-right">{this.props.data[c.account] !== null ? this.props.data[c.account] : 0}</td>
                                                    <td className="text-right">${this.props.data[c.account] > 0 ? (new Intl.NumberFormat().format(Math.round(this.props.data[c.aum] / (!isNaN(this.props.data[c.account]) ? this.props.data[c.account] : 5)))) : 0}</td>
                                                </tr>
                                            ))}
                                            {(clientAUMTotal < this.props.data['Total AUM'] || clientAccountTotal < this.props.data['Total Accounts']) ?
                                                <tr>
                                                    <td className="text-left other">Other (Not Listed Above)</td>
                                                    <td className="text-right other">${new Intl.NumberFormat().format(this.props.data['Total AUM'] - clientAUMTotal)}</td>
                                                    <td className="text-right other">{(this.props.data['Total Accounts'] - clientAccountTotal)}</td>
                                                    <td className="text-right other">{/*(clientAccountTotal - this.props.data['5F(2)(f) Total # accts.']) > 0 ? new Intl.NumberFormat().format(Math.round((clientAUMTotal - this.props.data['5F(2)(c) AUM Total']) / (clientAccountTotal - this.props.data['5F(2)(f) Total # accts.']))) : 0*/}</td>
                                                </tr>
                                                : <></>}
                                            {totalListFiltered.map(c => (
                                                <tr key={c.type}>
                                                    <td className="text-left total">{c.type}</td>
                                                    <td className="text-right total">${new Intl.NumberFormat().format(this.props.data[c.aum])}</td>
                                                    <td className="text-right total">{this.props.data[c.account] !== null ? this.props.data[c.account] : 0}</td>
                                                    <td className="text-right total">${this.props.data[c.account] > 0 ? new Intl.NumberFormat().format(Math.round(this.props.data[c.aum] / (!isNaN(this.props.data[c.account]) ? this.props.data[c.account] : 5))) : 0}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    :
                                    <Row className="align-items-center">
                                        <Col md="12" className="text-left"><p>No chart data available for {[...this.props.available_dates].filter(item => item.date_key === this.props.currentDate)[0].date_string}</p></Col>
                                    </Row>}
                            </Col>
                            <Col md={12} xl={7}>
                                <DemographicsGraph
                                    clientToken={this.props.clientToken}
                                    columns={2}
                                    data={this.props.graphData}
                                    scaleAxesAUM={this.props.scaleAxesAUM}
                                    scaleAxesAccounts={this.props.scaleAxesAccounts}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </CollapseCard>
        );
    }
}

export default AdvisorView;